// STOCK, SHOPIFY_VARIANTS and PRODUCT_IMAGES are injected by Liquid.
// See the inline script in sections/hol-main.liquid (English) or hol-zh-main.liquid (Chinese).

// ---------- INTERFACE STRINGS ----------
// Every piece of text this file puts on the page goes through t(). The English
// page sets nothing and gets the defaults; the Chinese page sets window.HOL_T
// before this script loads. One file, both languages - so a fix to the cart or
// the stock badge only ever has to be made once.
var HOL_T = window.HOL_T || {};
function t(key, fallback) {
  return (HOL_T[key] !== undefined && HOL_T[key] !== null) ? HOL_T[key] : fallback;
}

// ---------- VARIANT TOGGLE ----------
// Works for any number of variants. The panels are found by their id prefix
// within the same offering row, so the wood blocks can use scented/unscented
// while the sticker uses 1/3/11, with no change here.
function pickVariant(btn, blockId, variant) {
  btn.closest('.oil-toggle').querySelectorAll('.oil-tab').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');

  var scope = btn.closest('.offering-row') || document;
  var prefix = blockId + '-';
  scope.querySelectorAll('.vpanel').forEach(function(p){
    if(p.id && p.id.indexOf(prefix) === 0){
      p.style.display = (p.id === prefix + variant) ? '' : 'none';
    }
  });

  if(window.PRODUCT_IMAGES && PRODUCT_IMAGES[blockId] && PRODUCT_IMAGES[blockId][variant]){
    var imgs = PRODUCT_IMAGES[blockId][variant];
    var mainImg = document.getElementById(blockId+'-main-img');
    var strip = document.getElementById(blockId+'-thumbs');
    if(mainImg && imgs[0]) mainImg.src = imgs[0];
    if(strip){
      strip.querySelectorAll('img').forEach(function(t,i){
        if(imgs[i]) t.src = imgs[i];
        t.classList.toggle('active', i===0);
      });
    }
  }
}

// ---------- IMAGE GALLERY SWAP ----------
function swapImg(mainId, thumb, stripId) {
  document.getElementById(mainId).src = thumb.src;
  document.getElementById(stripId).querySelectorAll('img').forEach(function(t){t.classList.remove('active');});
  thumb.classList.add('active');
}

// ---------- STOCK DISPLAY ----------
// Exact counts at three and below, because the pieces are made to order and a
// real number is more honest than a vague "low stock" warning.
function renderStock(key) {
  var badge = document.getElementById(key+'-badge');
  var buyDiv = document.getElementById(key+'-buy');
  var soldDiv = document.getElementById(key+'-soldout');
  if(!badge) return;
  var count = (window.STOCK && STOCK[key] != null) ? STOCK[key] : 0;
  if(count <= 0){
    badge.textContent = '';
    badge.className = 'stock-badge stock-out';
    if(buyDiv) buyDiv.style.display = 'none';
    if(soldDiv) soldDiv.style.display = 'block';
  } else if(count === 1){
    badge.textContent = t('lastOne', 'Last one');
    badge.className = 'stock-badge stock-low';
    if(buyDiv) buyDiv.style.display = '';
    if(soldDiv) soldDiv.style.display = 'none';
  } else if(count <= 3){
    badge.textContent = t('onlyN', 'Only {n} remaining').replace('{n}', count);
    badge.className = 'stock-badge stock-low';
    if(buyDiv) buyDiv.style.display = '';
    if(soldDiv) soldDiv.style.display = 'none';
  } else {
    badge.textContent = t('inStock', 'In Stock');
    badge.className = 'stock-badge stock-in';
    if(buyDiv) buyDiv.style.display = '';
    if(soldDiv) soldDiv.style.display = 'none';
  }
}

// Every offering renders a <span class="stock-badge" id="KEY-badge">, so the list
// of products is read from the page rather than hard-coded here. Adding a new
// offering to a snippet is then enough - this file needs no edit.
function holStockKeys() {
  var keys = Array.prototype.map.call(
    document.querySelectorAll('.stock-badge[id$="-badge"]'),
    function(el){ return el.id.replace(/-badge$/, ''); }
  );
  return keys.filter(function(k){ return k && (!window.STOCK || STOCK[k] != null); });
}

// ---------- QUANTITY SELECTOR ----------
// Injected into every buy block so each product can be bought in multiples.
// Max is clamped to real stock so nobody can order more than exists.
function holMaxFor(key) {
  var n = (window.STOCK && STOCK[key] != null) ? STOCK[key] : 99;
  return n > 0 ? n : 1;
}

function holQty(key) {
  var input = document.getElementById('qty-'+key);
  if(!input) return 1;
  var v = parseInt(input.value, 10);
  if(isNaN(v) || v < 1) v = 1;
  var max = holMaxFor(key);
  if(v > max) v = max;
  input.value = v;
  return v;
}

function holStep(key, delta) {
  var input = document.getElementById('qty-'+key);
  if(!input) return;
  input.value = (parseInt(input.value, 10) || 1) + delta;
  holQty(key);
}

function holBuildQuantitySelectors() {
  if(!document.getElementById('hol-qty-style')){
    var st = document.createElement('style');
    st.id = 'hol-qty-style';
    st.textContent = '.hol-qty{display:flex;align-items:center;gap:.55rem;margin:.1rem 0 .7rem;}'
      + '.hol-qty-label{font-size:.52rem;letter-spacing:.22em;text-transform:uppercase;color:#A8886E;}'
      + '.hol-qty-box{display:flex;align-items:center;border:1px solid rgba(200,148,58,.35);border-radius:50px;overflow:hidden;}'
      + '.hol-qty-btn{width:30px;height:30px;background:none;border:none;cursor:pointer;font-family:inherit;font-size:1rem;line-height:1;color:#8B6B55;transition:background .25s;}'
      + '.hol-qty-btn:hover{background:rgba(200,148,58,.1);}'
      + '.hol-qty-btn:disabled{opacity:.3;cursor:default;}'
      + '.hol-qty-input{width:34px;text-align:center;border:none;background:none;font-family:inherit;font-size:.9rem;color:#8B6B55;-moz-appearance:textfield;}'
      + '.hol-qty-input::-webkit-outer-spin-button,.hol-qty-input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}';
    document.head.appendChild(st);
  }
  var labelText = t('quantity', 'Quantity');
  var lessLabel = t('qtyDown', 'Decrease quantity');
  var moreLabel = t('qtyUp', 'Increase quantity');
  document.querySelectorAll('[id$="-buy"]').forEach(function(buyDiv){
    var key = buyDiv.id.replace(/-buy$/, '');
    if(buyDiv.querySelector('.hol-qty')) return;
    var btn = buyDiv.querySelector('.btn-receive');
    if(!btn) return;
    var max = holMaxFor(key);
    var wrap = document.createElement('div');
    wrap.className = 'hol-qty';
    wrap.innerHTML = '<span class="hol-qty-label">'+labelText+'</span>'
      + '<span class="hol-qty-box">'
      + '<button type="button" class="hol-qty-btn" aria-label="'+lessLabel+'">&minus;</button>'
      + '<input class="hol-qty-input" id="qty-'+key+'" type="number" inputmode="numeric" min="1" max="'+max+'" value="1" aria-label="'+labelText+'"/>'
      + '<button type="button" class="hol-qty-btn" aria-label="'+moreLabel+'">+</button>'
      + '</span>';
    var btns = wrap.querySelectorAll('.hol-qty-btn');
    btns[0].addEventListener('click', function(){ holStep(key, -1); });
    btns[1].addEventListener('click', function(){ holStep(key, 1); });
    wrap.querySelector('.hol-qty-input').addEventListener('change', function(){ holQty(key); });
    buyDiv.insertBefore(wrap, btn);
  });
}

// ---------- ADD TO CART ----------
// Goes to /cart, not /checkout: people need to be able to review and adjust
// before they are asked for a delivery address.
function addToCart(productKey) {
  if(!window.SHOPIFY_VARIANTS) return;
  var variantId = SHOPIFY_VARIANTS[productKey];
  if(!variantId){ alert(t('cartError', 'Something went wrong. Please try again.')); return; }
  var quantity = holQty(productKey);
  var btn = document.getElementById('buy-btn-'+productKey);
  var orig = btn ? btn.textContent : '';
  if(btn){ btn.textContent = t('adding', 'Adding...'); btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items:[{id: variantId, quantity: quantity}]})
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    window.location.href = t('cartUrl', '/cart');
  })
  .catch(function(err){
    console.error('Cart error:', err);
    if(btn){ btn.textContent = orig; btn.disabled = false; }
    alert(t('cartError', 'Something went wrong. Please try again.'));
  });
}

// ---------- PREORDER / WAITLIST ----------
// Lucy's Chinese audience reaches her on LINE rather than WhatsApp, so the
// contact channel is a setting: the Chinese page sets HOL_T.contactUrl and the
// English page falls back to WhatsApp. A LINE share link cannot carry a
// pre-written message the way wa.me can, so the message is only attached to
// URLs that support it.
function holContactUrl(msg) {
  var base = t('contactUrl', 'https://wa.me/61438263377');
  if (base.indexOf('wa.me') !== -1) { return base + '?text=' + encodeURIComponent(msg); }
  return base;
}

function openPreorder(productName) {
  var msg = t('preorderMsg', 'Hi Lucy, I would like to pre-order the {p}. Please let me know about availability and delivery time. Thank you.')
      .replace('{p}', productName);
  window.open(holContactUrl(msg), '_blank');
  return false;
}

function openWaitlist(productName) {
  var msg = t('waitlistMsg', 'Hi Lucy, I would like to join the waitlist for {p}. Please notify me when it is back in stock. Thank you.')
      .replace('{p}', productName);
  window.open(holContactUrl(msg), '_blank');
  return false;
}

// ---------- VEIL + SCROLL REVEAL ----------
window.addEventListener('DOMContentLoaded', function(){
  holStockKeys().forEach(function(k){ renderStock(k); });
  holBuildQuantitySelectors();
});

window.addEventListener('load', function(){
  setTimeout(function(){ var v=document.getElementById('veil'); if(v) v.classList.add('gone'); }, 900);
});

var io = new IntersectionObserver(function(entries){
  entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); } });
}, {threshold:.07});
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
});
